import { JobRequirementAttachment } from './jobrequirement-attachment.model';
import { JobRequirementContact } from './jobrequirement-contact.model';

export interface DispatchDetail {
  badgeInfo: string;
  badgeRequest: string;
  contacts: JobRequirementContact[];
  dayShiftEnd: Date;
  dayShiftStart: Date;
  employeeJobDescription: string;
  gate: string;
  hrResourcePerDiem: string;
  manPowerAttachments: JobRequirementAttachment[];
  mappingPlatform: string;
  mileage: string;
  nightShiftEnd: Date;
  nightShiftStart: Date;
  notes: string;
  plantAddress: string;
  plantName: string;
  requirementDescription: string;
}
